import LockOutlined from '@mui/icons-material/LockOutlined';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { AppCard, AppLink, WhatsAppButton } from '@/components/atoms';
import { consultationAssurance, CONSULTATION_WHATSAPP_MESSAGE } from '@/content/consultation';
import { callablePhones } from '@/utils/phoneChannels';

import { assurance } from '../content';

/** The callable lines only: a WhatsApp desk is not the "call us now" option. */
const localPhones = callablePhones;

/**
 * The two things the rail still owes a visitor once the steps are read: what
 * happens to their number, and what to do if they would rather not fill a
 * form at all.
 *
 * The privacy line is beside the form rather than under the button on purpose
 * (§39). It answers the doubt that arrives while the number is being typed,
 * and under the submit it is read after the decision it was meant to inform.
 *
 * The escape hatch is the half that earns the card. A form is the wrong
 * channel for some people and no amount of layout changes that — so the page
 * offers the phone and WhatsApp *next to* the form instead of treating a
 * visitor who will not fill it in as lost. It matters more here than it would
 * on a quotation page: this form now requires an email address, and the
 * visitor who does not want to give one still has a way through. The numbers are read from
 * `config/company.ts`, never retyped, so this card cannot drift from the
 * footer or the structured data.
 *
 * No state, and nothing here decides anything: the copy is in `content.ts`
 * and the shared `content/consultation.ts`, and the WhatsApp button renders
 * itself away when no number is configured.
 */
export function AdviceAssurance() {
  return (
    <AppCard sx={{ p: { xs: 5, md: 6 } }}>
      <Stack spacing={5}>
        <Stack direction="row" spacing={3} alignItems="flex-start">
          <LockOutlined aria-hidden sx={{ fontSize: 20, mt: '2px', color: 'primary.main' }} />
          <Typography variant="body2" color="text.secondary">
            {consultationAssurance.privacy}
          </Typography>
        </Stack>

        <Stack spacing={3} alignItems="flex-start">
          <Typography variant="subtitle2" component="h3" sx={{ fontWeight: 700 }}>
            {assurance.talkNowTitle}
          </Typography>
          <Stack spacing={1}>
            {localPhones.map((phone) => (
              <AppLink key={phone.e164} href={`tel:${phone.e164}`}>
                {phone.display}
              </AppLink>
            ))}
          </Stack>
          <WhatsAppButton message={CONSULTATION_WHATSAPP_MESSAGE} size="small">
            Message us on WhatsApp
          </WhatsAppButton>
        </Stack>
      </Stack>
    </AppCard>
  );
}
